module.exports = __webpack_public_path__ + "assets/img/user-head-large.5a6314a4.png";